export default __webpack_public_path__ + "db9bde1405cb187e2a891020694315e1.svg";